/**
 * Modes opérationnels tournée — aligné avec `backend/src/domain/planning/tourneeOperationalMode.ts`
 * et l’enum Prisma `TourneeModeOperationnel`.
 */
export const TourneeOperationalMode = {
  WALKING: "WALKING",
  TRICYCLE: "TRICYCLE",
  MOTO: "MOTO",
  LIGHT_VEHICLE: "LIGHT_VEHICLE",
  TRUCK: "TRUCK",
  SUBCONTRACTOR: "SUBCONTRACTOR",
  MANUAL: "MANUAL",
} as const;

export type TourneeOperationalMode = (typeof TourneeOperationalMode)[keyof typeof TourneeOperationalMode];

export const TOURNEE_OPERATIONAL_MODE_OPTIONS: ReadonlyArray<{ value: TourneeOperationalMode; label: string }> = [
  { value: TourneeOperationalMode.WALKING, label: "À pied / Sans véhicule" },
  { value: TourneeOperationalMode.TRICYCLE, label: "Tricycle" },
  { value: TourneeOperationalMode.MOTO, label: "Moto" },
  { value: TourneeOperationalMode.LIGHT_VEHICLE, label: "Véhicule léger" },
  { value: TourneeOperationalMode.TRUCK, label: "Camion" },
  { value: TourneeOperationalMode.SUBCONTRACTOR, label: "Sous-traitant" },
  { value: TourneeOperationalMode.MANUAL, label: "Manuel / Autre" },
];

export function tourneeOperationalModeLabelFr(mode: TourneeOperationalMode | string): string {
  const row = TOURNEE_OPERATIONAL_MODE_OPTIONS.find((o) => o.value === mode);
  return row?.label ?? String(mode);
}

/** Modes pour lesquels l’UI peut proposer un véhicule charroi (optionnel, jamais obligatoire). */
export function tourneeModeAllowsOptionalFleetVehicle(mode: TourneeOperationalMode): boolean {
  return (
    mode === TourneeOperationalMode.MOTO ||
    mode === TourneeOperationalMode.LIGHT_VEHICLE ||
    mode === TourneeOperationalMode.TRUCK
  );
}

export function tourneeModeRequiresRollingUnit(mode: TourneeOperationalMode): boolean {
  return (
    mode === TourneeOperationalMode.TRICYCLE ||
    mode === TourneeOperationalMode.MOTO ||
    mode === TourneeOperationalMode.LIGHT_VEHICLE ||
    mode === TourneeOperationalMode.TRUCK
  );
}
